import React, { Component, Fragment } from "react";
import {Doughnut} from "react-chartjs-2";
import {CommandBarButton} from "office-ui-fabric-react";
import _ from "lodash";
import {DEFAULT_CHART_COLOURS} from "../../pages/admin/workloads/WorkloadResultsCharts";
import ComparisonBreakdown from "../../../models/mailroom/comparison/ComparisonBreakdown";
import ComparisonCounts from "../../../models/mailroom/comparison/ComparisonCounts";

interface ComparisonBreakdownChartsProps {
    breakdown: ComparisonBreakdown;
    onCloseClicked(): void;
}

interface ComparisonBreakdownChartsState {
}

export default class ComparisonBreakdownCharts extends Component<ComparisonBreakdownChartsProps, ComparisonBreakdownChartsState> {

    constructor(props: ComparisonBreakdownChartsProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {
    }

    async componentDidUpdate(prevProps: Readonly<ComparisonBreakdownChartsProps>, prevState: Readonly<ComparisonBreakdownChartsState>, snapshot?: any): Promise<void> {
        
    }

    
    private renderDoughnut(title: string, selectData: (counts: ComparisonCounts) => number): JSX.Element
    {
        const keys = _.keys(this.props.breakdown.byProcessorItemType).filter(key => key !== "$type");
        const data = 
        {
            labels: keys,
            datasets: [{
                data: keys.map(i => selectData(this.props.breakdown.byProcessorItemType[i])),
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };
        
        const options =  {
            legend: {
                display: true,
                position: "right"
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem: any, data:any) => {
                        return data.labels[tooltipItem.index] +' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%';
                    }
                }
            },
            title: {
                text: title,
                display: true,
                position: "bottom",
                fontStyle: "light",
                fontColor: "rgba(0,0,0,0.8)"
            }
        };
        
        return (
            <div className="doughnut-holder">
                <Doughnut options={options} data={data} height={1} width={1} />
            </div>
        );
    }
    
    
    render(): JSX.Element {
        
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Comparison Breakdown</span>
                        <CommandBarButton
                            iconProps={{iconName: "Cancel"}}
                            text="Close"
                            onClick={this.props.onCloseClicked}
                        />
                    </div>
                    <div className="card__content flex-column">
                        <div className={"flex-row flex--justify-content-space-around"}>
                            {this.renderDoughnut("Added",x => x.addedCount)}
                            {this.renderDoughnut("Changed",x => x.changedCount)}
                            {this.renderDoughnut("Removed",x => x.removedCount)}
                            {this.renderDoughnut("Total",x => x.total)}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
